import React from 'react';
import { X } from 'lucide-react';

/**
 * ModalHeader component
 * Displays the header of the modal with a title and close button
 */
const ModalHeader = ({ title, onClose }) => {
  return (
    <div className="p-4 md:p-6 border-b border-gray-800 flex justify-between items-center">
      <h2 className="text-2xl font-bold text-white">{title}</h2>
      <button 
        className="text-gray-400 hover:text-white p-2 rounded-full hover:bg-gray-800/50 transition-colors"
        onClick={onClose}
      >
        <X className="h-6 w-6" />
      </button>
    </div>
  );
};

export default ModalHeader;